import { render } from "./KeyboardActionsDescription.vue?vue&type=template&id=bcf0f440&scoped=true"
import script from "./KeyboardActionsDescription.vue?vue&type=script&lang=js"
export * from "./KeyboardActionsDescription.vue?vue&type=script&lang=js"

import "../../assets/scss/document_top_bar.scss?vue&type=style&index=0&id=bcf0f440&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcf0f440"]])

export default __exports__